/**
 * Created by shubham on 8/5/18.
 */

import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../../../shared/services/http.service';
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { MdDialog,MdDialogRef  } from '@angular/material';
import { DialogComponent } from '../../../dialog/dialog.component';
import { CommonService } from '../../../shared/services/common.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ApplicationListPage } from "../applicationList-datatable/applicationList-page";
import { APPCONFIG } from '../../../config';
import { ApplicationListDashboardResultService } from "../applicationListDashboardResultService";
import {TranslateService} from 'ng2-translate';
import { AdminListDashboardResultService } from "../../adminManagement/adminListDashboardResultService";


@Component({
    selector: 'applicationList',
    template: require('./applicationList.component.html')
})
export class ApplicationListComponent {

    @ViewChild(DatatableComponent) table: DatatableComponent;
    dialogRef;
    userDetails:any;
    page = new ApplicationListPage();
    tableRows :any = [];
    filters:any = {};
    rows:any;
    applicationListData = [];
    temp = [];
    showTable:boolean = true;
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    selected = [];
    StatusData: any;
    selectedStatusId: boolean;
    adminRoles: any;
    defaulAdminId: any;
    applicationListText: any;
    FiltersForm: FormGroup;
    applicationName = '';
    wpassId = '';
    isDisabled = false;
    dataTableMessage = {'selectedMessage':'','totalMessage':''};

    constructor(private router: Router, private httpService:HttpService, private sessionHandler:SessionHandler, public dialog: MdDialog,
                private formBuilder: FormBuilder, private serverResultsService: ApplicationListDashboardResultService, 
                private commonService: CommonService, private translate: TranslateService) {

        this.applicationListText = 'applicationList';

        //Assign Active or Inactive status
        this.StatusData = [
            {
                "id": true,
                "code": "ACTIVE",
                "name": "Active"
            }, {
                "id": false,
                "code": "INACTIVE",
                "name": "Inactive"
            }
        ];
        this.selectedStatusId = true;

        this.page.pageNumber = 0;
        this.page.size = 20;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));

        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if(this.isSystemAdmin){
            this.getAdminRoles();
        } else{
            this.getUserList();
        }

        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.applicationList.subscribe((value) => {
            this.getApplicationList(this.filters, this.selectedStatusId, this.defaulAdminId, this.applicationName);
        });
    }

    public getAdminRoles(){
        this.httpService.getRequest('superUserOperationsApi/v1/adminRoles').subscribe(
            res => { this.saveAdminRoles(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveAdminRoles(res){
        if(res && res.items){
            this.adminRoles = res.items;
            for(let a in this.adminRoles){
                if(this.adminRoles[a]['code'] == APPCONFIG.BUManager){
                    this.defaulAdminId = this.adminRoles[a]['id'];
                }
            }
            if(!this.defaulAdminId) {
                this.defaulAdminId = this.adminRoles[0]['id'];
            }
            this.getApplicationList(this.filters, this.selectedStatusId, this.defaulAdminId, this.applicationName);
        }else {
            this.httpService.onEnd();
        }
    }

    buildForm() {
        this.FiltersForm = this.formBuilder.group({
            applicationName: this.formBuilder.control({value: '', disabled: this.isDisabled}),
            wpassId: this.formBuilder.control(''),
        });
        this.FiltersForm.valueChanges.subscribe(data => {
            this.applicationName = this.FiltersForm.get('applicationName').value;
        });
    }

    disablefields(value: String) {
        if(value != ''){
            this.FiltersForm.controls['applicationName'].setValue('');
            this.FiltersForm.controls['applicationName'].disable();
        } else{
            this.FiltersForm.controls['applicationName'].enable();
        }
    }

    public search(){
        this.filters['offSet'] = 0;
        this.getApplicationList(this.filters, this.selectedStatusId, this.defaulAdminId, this.applicationName);
    }

    public resetSearch(){
        this.FiltersForm.controls['applicationName'].enable();
        this.FiltersForm.reset();
        this.applicationName = '';
        this.search();
    }

    public getApplicationList(filter, selectedStatus, defaulAdminId, applicationName ){
        this.httpService.getRequest("applicationOperationApi/v1/applicationList?limit="+filter.limit+"&offset="+filter.offSet+"&role="+defaulAdminId+"&active="+selectedStatus+"&applicationName="+applicationName).subscribe(
            res => { this.saveUserList(res,filter); },
            err => { this.httpService.onEnd();}
        );
    }

    public getUserList = function () {
        this.showTable = false;
    }

    public saveUserList = function(res, filter){
        if(res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_pull_fail';
        } else {
            if(res && Object.keys(res).length > 0 ){
                this.applicationListData = res;
                this.rows = [];
                this.rows['offset'] = res.offset;

                if(this.applicationListData.list) {
                    let totalCount = 0;
                    if (parseInt(res.offset) == 0) {
                        localStorage.setItem('totalCount', res.totalCount);
                        totalCount = parseInt(res.totalCount);
                    } else {
                        totalCount = parseInt(localStorage.getItem('totalCount'));
                    }

                    this.rows['totalCount'] = totalCount;
                    for (let data in this.applicationListData.list) {
                        if(this.isSystemAdmin){
                            this.rows[data] = {};
                            this.rows[data]['id'] = this.applicationListData.list[data]['id'];
                            this.rows[data]['applicationName'] = this.applicationListData.list[data]['applicationName'];
                            this.rows[data]['ldapApplicationId'] = this.applicationListData.list[data]['ldapApplicationId'];
                            this.rows[data]['managerNames'] = this.applicationListData.list[data]['managerNames'];
                            this.rows[data]['customerNumberRequired'] = this.applicationListData.list[data]['customerNumberRequired'];
                            this.rows[data]['skipManagerApproval'] = this.applicationListData.list[data]['skipManagerApproval'];
                            this.rows[data]['multipleRole'] = this.applicationListData.list[data]['multipleRole'];

                            if(this.applicationListData.list[data]['active'] == true){
                                this.rows[data]['status'] = 'Active';
                            } else{
                                this.rows[data]['status'] = 'Inactive';
                            }

                            this.rows[data]['active'] = this.applicationListData.list[data]['active'];
                            this.rows[data]['createdAt'] = this.applicationListData.list[data]['createdAt'];
                        } else{
                            //For Other Service Partner's
                            this.rows[data] = {};
                        }
                    }
                    this.showTable = true;
                    this.temp = this.rows;
                } else{
                    this.showTable = false;
                }

                let finalRows = [];
                for(let f in this.rows){
                    if(f != 'offset' && f !='totalCount' && this.rows[f]){
                        finalRows.push(this.rows[f]);
                    }
                    if(f == 'offset'){
                        finalRows['offset'] = this.rows['offset'];
                    }
                    if(f == 'totalCount'){
                        finalRows['totalCount'] = this.rows['totalCount'];
                    }
                }
                this.rows = finalRows;
                this.setPage({ offset: this.rows['offset']/this.page.size },finalRows,filter);
                this.httpService.onEnd();
            }
        }
    }

    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    public setPage(pageInfo,rows,filter){
        this.page.pageNumber = pageInfo.offset;
        if(rows.length != 0){
            this.serverResultsService.getResults(this.page,rows).subscribe(pageData => {
                this.page = pageData.page;
                this.tableRows = pageData.data;
                if(!filter){
                    if(Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']){
                        this.filters['offSet'] = this.page.pageNumber * this.page.size;
                        this.getApplicationList(this.filters, this.selectedStatusId, this.defaulAdminId, this.applicationName);
                    }
                }
            });
        } else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    }

    onSelect({ selected }) {
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
    }

    ngOnInit(){
        this.buildForm();

        this.translate.get('total').subscribe((res: string) => {
            this.dataTableMessage.totalMessage=res;
        });
        this.translate.get('selected').subscribe((res: string) => {
            this.dataTableMessage.selectedMessage=res;
        });
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/applicationManagement/applicationList/applicationList.component.ts